/**
 * WebSocket event from TAP API /channel endpoint
 */
export interface TapChannelEvent {
  collection: string // 'app.bsky.feed.post'
  action: 'create' | 'update' | 'delete'
  uri: string
  cid: string
  did: string
  timestamp: number
  record?: any
  // TAP extensions
  hasVideo?: boolean
  hasImages?: boolean
  hasGif?: boolean
  tags?: Array<{slug: string; name: string}>
}

/**
 * Connection status for TapFeedUpdatesEventBus
 */
export enum TapFeedUpdatesStatus {
  Initializing = 'initializing',
  Connected = 'connected',
  Reconnecting = 'reconnecting',
  Backgrounded = 'backgrounded',
  Suspended = 'suspended',
  Error = 'error',
}

/**
 * Events emitted by TapFeedUpdatesEventBus
 */
export type TapFeedUpdateEvent =
  | {type: 'connect'}
  | {type: 'disconnect'}
  | {type: 'error'; error: Error}
  | {type: 'batch'; events: TapChannelEvent[]}

/**
 * Parameters for initializing TapFeedUpdatesEventBus
 */
export interface TapFeedUpdatesParams {
  accessToken: string | undefined
  queryClient: any // QueryClient from @tanstack/react-query
}
